module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/file-plus-529bb7b5f2477c1e93e739cf1f016e78.svg";